import { render, staticRenderFns } from "./ModalAddTemplate.vue?vue&type=template&id=4a9cb216&scoped=true"
import script from "./ModalAddTemplate.vue?vue&type=script&lang=js"
export * from "./ModalAddTemplate.vue?vue&type=script&lang=js"
import style0 from "./ModalAddTemplate.vue?vue&type=style&index=0&id=4a9cb216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9cb216",
  null
  
)

export default component.exports